import styled from "styled-components";

import type { MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode } from "@similarweb/pro-api-client";

import { translate } from "app/filters/i18nFilter";

import { getAbsoluteFormat } from "../demand-over-time/utils/utils";

const HintContainer = styled.div`
    font-family: Roboto, sans-serif;
    font-weight: 400;
    width: 200px;
`;

const HintHeader = styled.div`
    font-weight: 700;
`;

const HintList = styled.ul`
    list-style-type: disc;
`;

const HintListItem = styled.li``;

interface IClusterLegendItemHintParams {
    keywords: MarketResearchDemandAnalysisCalculationModelsSearchTrendsNode[];
}

const MAX_HINT_KEYWORDS = 5;

const ClusterLegendItemHint = ({ keywords }: IClusterLegendItemHintParams) => {
    const otherText = translate(
        keywords.length - MAX_HINT_KEYWORDS === 1
            ? "demand.analysis.search.trends.other.keywords.singular"
            : "demand.analysis.search.trends.other.keywords",
        {
            countOfOtherKeywords: keywords.length - MAX_HINT_KEYWORDS,
        },
    );
    const otherVolume = getAbsoluteFormat(
        keywords.slice(MAX_HINT_KEYWORDS).reduce((acc, curr) => acc + curr.currentPeriod.averageVolume, 0),
    );
    return (
        <HintContainer>
            <HintHeader>
                {keywords.length}{" "}
                {translate(keywords.length > 1 ? "common.keywords.lowercase" : "common.keyword.lowercase")}
            </HintHeader>
            <HintList>
                {keywords.slice(0, MAX_HINT_KEYWORDS).map((row, index) => (
                    <HintListItem key={`${row.name}_${index}`}>
                        {row.name} - {getAbsoluteFormat(row.currentPeriod.averageVolume)}
                    </HintListItem>
                ))}
                {keywords.length > MAX_HINT_KEYWORDS ? (
                    <HintListItem key={`OTHER_${MAX_HINT_KEYWORDS + 1}`}>
                        {otherText} - {otherVolume}
                    </HintListItem>
                ) : null}
            </HintList>
        </HintContainer>
    );
};

export { ClusterLegendItemHint };
